<template>
  <div>
    <sample-header>
    </sample-header>
    <div class="content homepage">
      <!--<div class="homepage__gradient">-->
        <div class="homepage__hero">
          <div class="center-content">
            <div class="hero-rebate">
              <div class="text-header row">
                <div class="columns small-12">
                  <h1>Ready to order your Evaluation Product?</h1>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="columns small-12">
                <coupon-input>
                </coupon-input>
              </div>
            </div>
          </div>
        </div>
      <!--</div>-->
    </div>
    <sample-footer>
    </sample-footer>
  </div>
</template>

<script>
import SampleHeader from "@/components/layout/SampleHeader";
import SampleFooter from "@/components/layout/SampleFooter";
import CouponInput from "@/components/home/CouponInput";
//import CouponInput  from '@/components/CouponInput'
export default {
  name: "home",
  components: { SampleHeader, SampleFooter, CouponInput }
};
</script>
